import { Howl } from 'howler';

// Global
const globalAnswerCorrect = new Howl({
  src: ['/assets/practices/global/audio/answer_correct.wav'],
});
const globalAnswerIncorrect = new Howl({
  src: ['/assets/practices/global/audio/answer_incorrect.wav'],
});
const globalButton = new Howl({
  src: ['/assets/practices/global/audio/button.mp3'],
});
const globalButtonSettings = new Howl({
  src: ['/assets/practices/global/audio/settings/button_settings.wav'],
});
const globalScoreLose = new Howl({
  src: ['/assets/practices/global/audio/scoreLose.wav'],
});
const globalScorePass = new Howl({
  src: ['/assets/practices/global/audio/scorePass.wav'],
});
const globalScoreWin = new Howl({
  src: ['/assets/practices/global/audio/scoreWin.wav'],
});

// Clown to Water

const clownToWaterBackground = new Howl({
  src: ['/assets/practices/clown_to_water/audio/clown_to_water_background.mp3'],
  loop: true,
  volume: 0.25,
});

// Easter Egg
const easterEggBackground = new Howl({
  src: ['/assets/practices/easter_egg/audio/background_music.mp3'],
  loop: true,
  volume: 0.25,
});
const easterEggBunnySlide = new Howl({
  src: ['/assets/practices/easter_egg/audio/bunny_slide.wav'],
});
const easterEggCorrectAnswer = new Howl({
  src: ['/assets/practices/easter_egg/audio/answer_correct.wav'],
});
const easterEggCorrectEgg = new Howl({
  src: ['/assets/practices/easter_egg/audio/egg_right.wav'],
});
const easterEggIncorrectAnswer = new Howl({
  src: ['/assets/practices/easter_egg/audio/answer_incorrect.wav'],
});
const easterEggIncorrectEgg = new Howl({
  src: ['/assets/practices/easter_egg/audio/egg_wrong.wav'],
});
const easterEggWindBannerIn = new Howl({
  src: ['/assets/practices/easter_egg/audio/wind.wav'],
});
const easterEggWindBannerOut = new Howl({
  src: ['/assets/practices/easter_egg/audio/wind.wav'],
  rate: 0.75,
});

// Expanded Form
const expandedFormBackground = new Howl({
  src: ['/assets/practices/expanded_form/audio/expanded_form_background.mp3'],
  loop: true,
  volume: 0.25,
});
const expandedFormDragonFire = new Howl({
  src: ['/assets/practices/expanded_form/audio/expanded_form_dragon_fire.mp3'],
});
const expandedFormEggBurned = new Howl({
  src: ['/assets/practices/expanded_form/audio/expanded_form_egg_burned.mp3'],
});
const expandedFormEggGolden = new Howl({
  src: ['/assets/practices/expanded_form/audio/expanded_form_egg_golden.mp3'],
});
const expandedFormScrollHome = new Howl({
  src: ['/assets/practices/expanded_form/audio/expanded_form_home.mp3'],
});
const expandedFormSleepingDragon = new Howl({
  src: ['/assets/practices/expanded_form/audio/expanded_form_dragon_sleep.mp3'],
  loop: true,
  volume: 1.5,
});

// Fishy Problems
const fishyProblemsBackground = new Howl({
  src: ['/assets/practices/fishy_problems/audio/fishy_problems_background.mp3'],
  loop: true,
  volume: 0.25,
});
const fishyProblemsBubble = new Howl({
  src: ['/assets/practices/fishy_problems/audio/fishy_problems_bubble.wav'],
});
const fishyProblemsFishButton = new Howl({
  src: ['/assets/practices/fishy_problems/audio/fishy_problems_fish_button.mp3'],
});

// Pet Life
const petLifeBackground = new Howl({
  src: ['/assets/practices/pet_life/audio/pet_life_background.mp3'],
  loop: true,
  volume: 0.15,
});
const petLifeCatBlack = new Howl({
  src: ['/assets/practices/pet_life/audio/pet_life_cat_black.mp3'],
  loop: false,
  volume: 1.5,
});
const petLifeCatOrange = new Howl({
  src: ['/assets/practices/pet_life/audio/pet_life_cat_orange.mp3'],
  loop: false,
  volume: 1.5,
});
const petLifeCatWhite = new Howl({
  src: ['/assets/practices/pet_life/audio/pet_life_cat_white.mp3'],
  loop: false,
  volume: 1.5,
});
const petLifeCorrect = new Howl({
  src: ['/assets/practices/pet_life/audio/pet_life_correct.mp3'],
  volume: 1.5,
});
const petLifeIncorrect = new Howl({
  src: ['/assets/practices/pet_life/audio/pet_life_incorrect.mp3'],
  volume: 2.5,
});

// Pumpkin Clock
const pumpkinClockBackground = new Howl({
  src: ['/assets/practices/pumpkin_clock/audio/background_music.mp3'],
  loop: true,
  volume: 0.25,
});
const pumpkinClockClock = new Howl({
  src: ['/assets/practices/pumpkin_clock/audio/clock.mp3'],
  loop: true,
  volume: 0.25,
});
const pumpkinClockCorrectAnswer = new Howl({
  src: ['/assets/practices/pumpkin_clock/audio/answer_correct.wav'],
});
const pumpkinClockIncorrectAnswer = new Howl({
  src: ['/assets/practices/pumpkin_clock/audio/answer_incorrect.wav'],
});

// Saving Money
const savingMoneyBackground = new Howl({
  src: ['/assets/practices/saving_money/audio/background_music.mp3'],
  loop: true,
  volume: 0.25,
});
const savingMoneyCoinDropped = new Howl({
  src: ['/assets/practices/saving_money/audio/coin_dropped.wav'],
});

// Soccer Goal
const soccerGoalBackground = new Howl({
  src: ['/assets/practices/soccer_goal/audio/background_music.mp3'],
  loop: true,
  volume: 0.25,
});
const soccerGoalButtonStart = new Howl({
  src: ['/assets/practices/soccer_goal/audio/home_start.wav'],
});
const soccerGoalCorrectAnswer = new Howl({
  src: ['/assets/practices/soccer_goal/audio/correct.mp3'],
});
const soccerGoalIncorrectAnswer = new Howl({
  src: ['/assets/practices/soccer_goal/audio/incorrect.wav'],
});
const soccerGoalHomeBall = new Howl({
  src: ['/assets/practices/soccer_goal/audio/home_ball.mp3'],
});

const mute = boolean => {
  clownToWaterBackground.mute(boolean);
  easterEggBackground.mute(boolean);
  easterEggBunnySlide.mute(boolean);
  easterEggCorrectAnswer.mute(boolean);
  easterEggCorrectEgg.mute(boolean);
  easterEggIncorrectAnswer.mute(boolean);
  easterEggIncorrectEgg.mute(boolean);
  easterEggWindBannerIn.mute(boolean);
  easterEggWindBannerOut.mute(boolean);
  expandedFormBackground.mute(boolean);
  expandedFormDragonFire.mute(boolean);
  expandedFormEggBurned.mute(boolean);
  expandedFormEggGolden.mute(boolean);
  expandedFormScrollHome.mute(boolean);
  expandedFormSleepingDragon.mute(boolean);
  fishyProblemsBackground.mute(boolean);
  fishyProblemsBubble.mute(boolean);
  fishyProblemsFishButton.mute(boolean);
  globalAnswerCorrect.mute(boolean);
  globalAnswerIncorrect.mute(boolean);
  globalButton.mute(boolean);
  globalButtonSettings.mute(boolean);
  globalScoreLose.mute(boolean);
  globalScorePass.mute(boolean);
  globalScoreWin.mute(boolean);
  petLifeBackground.mute(boolean);
  petLifeCatBlack.mute(boolean);
  petLifeCatOrange.mute(boolean);
  petLifeCatWhite.mute(boolean);
  petLifeCorrect.mute(boolean);
  petLifeIncorrect.mute(boolean);
  pumpkinClockBackground.mute(boolean);
  pumpkinClockClock.mute(boolean);
  pumpkinClockCorrectAnswer.mute(boolean);
  pumpkinClockIncorrectAnswer.mute(boolean);
  savingMoneyBackground.mute(boolean);
  savingMoneyCoinDropped.mute(boolean);
  soccerGoalBackground.mute(boolean);
  soccerGoalButtonStart.mute(boolean);
  soccerGoalCorrectAnswer.mute(boolean);
  soccerGoalIncorrectAnswer.mute(boolean);
  soccerGoalHomeBall.mute(boolean);
};

export default {
  clownToWaterBackground,
  easterEggBackground,
  easterEggBunnySlide,
  easterEggCorrectAnswer,
  easterEggCorrectEgg,
  easterEggIncorrectAnswer,
  easterEggIncorrectEgg,
  easterEggWindBannerIn,
  easterEggWindBannerOut,
  expandedFormBackground,
  expandedFormDragonFire,
  expandedFormEggBurned,
  expandedFormEggGolden,
  expandedFormScrollHome,
  expandedFormSleepingDragon,
  fishyProblemsBackground,
  fishyProblemsBubble,
  fishyProblemsFishButton,
  globalAnswerCorrect,
  globalAnswerIncorrect,
  globalButton,
  globalButtonSettings,
  globalScoreLose,
  globalScorePass,
  globalScoreWin,
  mute,
  petLifeBackground,
  petLifeCatBlack,
  petLifeCatOrange,
  petLifeCatWhite,
  petLifeCorrect,
  petLifeIncorrect,
  pumpkinClockBackground,
  pumpkinClockClock,
  pumpkinClockCorrectAnswer,
  pumpkinClockIncorrectAnswer,
  savingMoneyBackground,
  savingMoneyCoinDropped,
  soccerGoalBackground,
  soccerGoalButtonStart,
  soccerGoalCorrectAnswer,
  soccerGoalIncorrectAnswer,
  soccerGoalHomeBall,
};
